import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiDocsComponent } from './api-docs.component';
import { GettingStartedComponent } from './components/getting-started/getting-started.component';
import { AuthenticationComponent } from './components/authentication/authentication.component';
import { SharedModule } from 'projects/partner/src/app/shared/shared.module';
import { TestScenariosComponent } from './components/test-scenarios/test-scenarios.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ApiDocsComponent,
    GettingStartedComponent,
    AuthenticationComponent,
    TestScenariosComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    ApiDocsComponent
  ]
})
export class ApiDocsModule { }
